import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-custom card-stretch mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-header align-items-center border-0 mt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-dark fs-3" }, "Sales Share"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-2 fw-bold fs-6" }, "890,344 Sales")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "card-body pt-12" }
const _hoisted_8 = {
  class: "d-flex flex-center position-relative bgi-no-repeat bgi-size-contain bgi-position-x-center bgi-position-y-center h-175px",
  style: {"background-image":"url('media/svg/illustrations/bg-1.svg')"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-1 text-gray-800 position-absolute" }, " 8,345 ", -1)
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-around pt-18\"><div class=\"\"><span class=\"fw-bolder text-gray-800\">48% SNT</span><span class=\"bg-info w-25px h-5px d-block rounded mt-1\"></span></div><div class=\"\"><span class=\"fw-bolder text-gray-800\">20% REX</span><span class=\"bg-primary w-25px h-5px d-block rounded mt-1\"></span></div><div class=\"\"><span class=\"fw-bolder text-gray-800\">32% SAP</span><span class=\"bg-warning w-25px h-5px d-block rounded mt-1\"></span></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown3)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_apexchart, {
          width: "270",
          type: "donut",
          options: _ctx.options,
          series: _ctx.series
        }, null, 8, ["options", "series"])
      ]),
      _hoisted_10
    ])
  ]))
}